import { FC } from 'react';
import { CancelWarrantyDetail } from './CancelWarrantyDetail/CancelWarrantyDetail';
import { store } from '@/config/store';

export const CancelWarrantyDetailPage: FC = () => {
  const { currentWarranty: warranty } = store.state;
  return <CancelWarrantyDetail warranty={warranty} />;
};
